import React, { useState, useMemo, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import configs from '../../../../config/config';
import '../../../../assets/stylesheets/Dialogs/AgentDetails.scss';
import OptionRow from '../../../Profile/OptionRow';
import RealTabSwitcher from '../../../Units/RealTabSwitcher';
import { useDispatch, useSelector } from 'react-redux';
import { closeDialog } from '../../../../store/actionCreators/dialog';
import { agentDetailsRequest } from '../../../../store/actionCreators/member';
import { getCurrentAgentDetails, getCurrentClubApprovedMembers } from '../../../../store/selectors';

const { clubCurrency } = configs;

const chips = [
    { name: 'Credit Balance', count: 200 }, { name: "Downline's Chips", count: 150 }, { name: 'Chips In Play', count: 150 }
];
const fees = [
    { name: 'Poker Fees', count: 200, date: 'Last Week' },
    { name: 'Poker Fees', count: 200, date: 'This Week' }
];
const winnings = [
    { name: 'Winnings Last Week', count: 200 }, {name: 'Winnings this Week', count: 400 }
]

const tabs = [{ name: 'total' }, { name: 'lastWeek' }, { name: 'currentWeek' }];

const AgentDetails = ({ clubId, memberId }) => {
  const { t } = useTranslation();
    const dispatch = useDispatch();
    const stats = useSelector(getCurrentAgentDetails);
    const summary = stats.summary || {};

    const memberList = useSelector(getCurrentClubApprovedMembers);
    const agent = memberList.find(m => m.roleAccountId === memberId);

    const [mode, setMode] = useState(tabs[0].name);
    const [dateFrom, dateTo] = useMemo(() => {
        if (mode === 'total') return [null, null];
        if (mode === 'currentWeek') return [
            moment().startOf('week').toISOString(),
            moment().endOf('week').toISOString(),
        ];
        return [
            moment().subtract(7, 'days').startOf('week').toISOString(),
            moment().subtract(7, 'days').endOf('week').toISOString(),
        ];
    }, [mode]);

    const close = useCallback(() => {
        dispatch(closeDialog('agentDetails'));
    }, []);

    useEffect(() => {
        dispatch(agentDetailsRequest(memberId, dateFrom, dateTo));
    }, [dateFrom, dateTo]);

    return (
        <div className="agentDetails">
            <div className="winnings">
                <div className="winItem">
                    <p>{stats.creditBalance || 0}</p>
                    <p>{t('creditBalance')}</p>
                </div>
                <div className="winItem">
                    <p>{stats.downlineAccountsBalance || 0}</p>
                    <p>{t('downlinesChips', {clubCurrency: t(`clubCurrency.plural.${clubCurrency}`)})}</p>
                </div>
                <div className="winItem">
                    <p>0</p>
                    <p>{t('chipsInPlay', {clubCurrency: t(`clubCurrency.plural.${clubCurrency}`)})}</p>
                </div>
            </div>
            <RealTabSwitcher tabs={tabs} onChange={setMode} selected={mode} />
            <div className="winnings">
                <div className="winItem">
                    <p>{stats.overallWL || 0}</p>
                    <p>{t('overallWL')}</p>
                </div>
                <div className="winItem">
                    <p>{summary.poker ? summary.poker.wl : 0}</p>
                    <p>{t('pokerWL')}</p>
                </div>
                <div className="winItem">
                    <p>{summary.poker ? summary.poker.fee : 0}</p>
                    <p>{t('pokerFees')}</p>
                </div>
                <div className="winItem">
                    <p>{summary.casino ? summary.casino.wl : 0}</p>
                    <p>{t('casinoWL')}</p>
                </div>
                <div className="winItem">
                    <p>{summary.liveCasino ? summary.liveCasino.wl : 0}</p>
                    <p>{t('liveCasinoWL')}</p>
                </div>
                <div className="winItem">
                    <p>{summary.sports ? summary.sports.wl : 0}</p>
                    <p>{t('sportsWL')}</p>
                </div>
            </div>
            <div onClick={()=>close()}>
                <OptionRow option="memberAmount" section="agentDetails"  to={`/club/${clubId}/members/${agent._id}/agentMenu`}
                  params={{ memberAmount: stats.memberCount || 0 }}
                />
            </div>
        </div>
    );
};

export default AgentDetails;
